import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

const Container = styled.div`
    background: white;
    padding: 0.5em;
    border-radius: 10px;
    display: flex;
`;

const Header = styled.h1`
    color: black;
    font-weight: 600;
    font-size: 18px;
`;

const Paragraph = styled.p`
    color: ${(props) => props.theme.color.grey1};
    font-size: 16px;
`;

const IconStyles = styled.svg`
    color: ${(props) => props.theme.color.highlightColor};
    box-sizing: content-box;
    padding: 0 10px 0 5px;
`;

function HeaderContent({ title, children, Icon = () => null }) {
    return (
        <Container>
            <IconStyles as={Icon} width={40} />
            <div>
                <Header>{title}</Header>
                <Paragraph>{children}</Paragraph>
            </div>
        </Container>
    );
}

HeaderContent.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    Icon: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.elementType,
        PropTypes.func,
    ]),
};

export default HeaderContent;
